<template>
  <div class="qr" :class="{ 'qr-border' : qrBorder }">
    <canvas ref="canvas" />
    <div v-if="isErrorQr" class="qr-error">
      {{ $t('error') }}
      <br>
      {{ $t('tryAgain') }}
    </div>
  </div>
</template>

<script>
import * as QRCode from 'qrcode';

export default {
  name: 'VacancyListQr',
  props: {
    url: {
      type: String,
      required: true,
    },
    vacancyListId: {
      type: Number,
      required: true,
    },
    qrBorder: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isErrorQr: false,
    };
  },
  mounted() {
    try {
      QRCode.toCanvas(
        this.$refs.canvas,
        this.url,
        { errorCorrectionLevel: 'H' },
        (error) => {
          if (error) this.handleQrError(error);
        },
      );
    } catch (error) {
      this.handleQrError(error);
    }
  },
  methods: {
    handleQrError(error) {
      this.isErrorQr = true;
      if (process.env.NODE_ENV === 'development') {
        console.error('QR Code Generation Error:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.qr {
  position: relative;
  width: 8.0625rem;
  height: 8.0625rem;
  padding: 0.9375rem;
  canvas {
    max-width: 100%;
    max-height: 100%;
  }
}

.qr-border {
  border: 1px solid #EEEEEE;
  border-radius: 0.25rem;
}
.qr-error {
  position: absolute;
  top: 30px;
  left: 0;
  text-align: center;
  font-size: 12px;
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .qr {
    width: 6rem;
    height: 6rem;
    padding: 0.5rem;
  }
}
</style>

<i18n lang="yml" locale="ru">
  error: Ошибка при генерации QR-кода.
  tryAgain: Попробуйте снова.
</i18n>
<i18n lang="yml" locale="en">
  error: Error when generating the QR code.
  tryAgain: Try again.
</i18n>
